<script setup lang="ts">
import type { DownloadJob } from "~/classes/job/DownloadJob"

const { sortedNotifications, clearNotifications, state: notificationState } = useNotificationTray()
const { isOffline, nextReconnectDate } = useCache()

// TODO: fade in and out peek view
</script>

<template>
  <dropdown-menu
    v-if="notificationState.isPeek && sortedNotifications.length > 0"
    class="peek-container"
  >
    <div
      v-for="key in range(Math.min(sortedNotifications.length - 1, 3))"
      :key
      class="card"
      @click="notificationState.isPeek = false"
    />
    <template v-for="alert in [sortedNotifications[0]]" :key="alert.transferId">
      <nav-tray-job-upload
        v-if="alert.type === 'upload'"
        class="peek-notification"
        :transfer-id="alert.transferId"
      />
      <nav-tray-job-download
        v-if="alert.type === 'download'"
        class="peek-notification"
        :transfer-id="alert.transferId"
      />
      <nav-tray-job-copy
        v-if="alert.type === 'copy'"
        class="peek-notification"
        :transfer-id="alert.transferId"
      />
      <nav-tray-alert
        v-else-if="alert.type === 'error-alert' || alert.type === 'success-alert'"
        class="peek-notification"
        :alert="(alert as AlertNotification)"
      />

      <div v-else>
        ???
      </div>
    </template>
    <div v-if="sortedNotifications.length > 1" class="more">
      <div class="inner" @click="notificationState.isPeek = false">
        {{ sortedNotifications.length - 1 }} More
      </div>
    </div>
  </dropdown-menu>
  <dropdown-menu v-else class="notification-container">
    <menu-section>
      <menu-header label="Activity Notifications" />
    </menu-section>
    <div class="notifications">
      <template v-for="alert in sortedNotifications" :key="alert.transferId">
        <nav-tray-alert
          v-if="alert.type === 'error-alert' || alert.type === 'success-alert'"
          :alert="(alert as AlertNotification)"
        />
        <nav-tray-job-upload
          v-else-if="alert.type === 'upload'"
          :transfer-id="alert.transferId"
        />
        <nav-tray-job-download
          v-else-if="alert.type === 'download'"
          :transfer-id="alert.transferId"
        />
        <nav-tray-job-copy
          v-else-if="alert.type === 'copy'"
          :transfer-id="alert.transferId"
        />
        <!-- <nav-tray-job-download
              v-else-if="alert.type === 'download'"
              :job="alert"
            /> -->
        <div v-else>
          Unknown message type
        </div>
      </template>
      <template v-if="sortedNotifications.length === 0">
        <menu-section class="no-notifications">
          You have no notifications
        </menu-section>
      </template>
    </div>
    <dropdown-chin>
      <template v-if="isOffline() && nextReconnectDate()">
        <div class="connection offline">
          <icon-action
            type="offline"
            size="xs"
            class="icon"
          />
          <div>Your are offline. Attempting to reconnect...</div>
        </div>
      </template>
      <template v-else-if="isOffline()">
        <div class="connection offline">
          <icon-action
            type="offline"
            size="xs"
            class="icon"
          />
          <div>Your are offline</div>
        </div>
      </template>
      <template v-else>
        <div class="connection online">
          <icon-action
            type="online"
            size="xs"
            class="icon"
          />
          <div>Connected</div>
        </div>
      </template>
    </dropdown-chin>
  </dropdown-menu>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'
.peek-container
  @apply w-[#{$menu-tray-w-default}]
  .peek-notification
    @apply z-1 rounded-[#{$menu-br-default}] overflow-hidden border-[#{$menu-b-outline}] border-[#{$menu-b-outline}] border
  .card
    @apply h-4 -mt-3 rounded-b-[#{$menu-br-default}] z-1 cursor-pointer
  .more
    @apply absolute bottom-0 flex justify-center w-full t-menu-2xs text-$global-t-secondary
    .inner
      @apply bg-[#{$menu-b-outline}] rounded-full z-2 px-1 cursor-pointer
      box-shadow: 0px 0px 4px #2C2C2C

.notification-container
  @apply w-[#{$menu-tray-w-default}]
  max-height: calc(100vh - 350px)

  .activity
    @apply text-[#{$global-t-default}] t-menu-sm
  .clear-all
    @apply text-[#{$global-t-tertiary}]
    @apply hover:bg-[#{$pill-bg-button-hover}]
    @apply hover:text-[#{$global-t-default}]
    @apply ml-auto px-2 py-1 -mr-2 -my-1 rounded-md cursor-pointer
  .notifications
    @apply
  .no-notifications
    @apply font-italic text-[#{$global-t-quaternary}] t-menu-sm

.connection
  @apply flex items-center gap-1 h-full
  &.online
    .icon
      @apply text-$global-green-primary
  &.offline
    .icon
      @apply text-$global-amber-primary
  .icon
    @apply w-4 h-4
</style>
